export default {
  tinyMCEApiKey: '2u7ys92oz2zm9283gfgl2dhkxq58wy449mncmiuaf9xm3lqw',
  // tinyMCEApiKey: 'jrlylea8yaye09nnarargvt80wkq1d8anl34t18c0kgedk1n',
  // tinyMCEApiKey: 'kbrpdnet7gsa6bfro15tj3q9soz8t1vbamqc6v7u4g13nw3x',
  DEV_MODE: process.env.NODE_ENV === 'development'
}



// WEBPACK FOOTER //
// ./src/settings.js